/**
 * 共通メッセージ定義
 */
export default {
  en: {
    error: {
      SYSERR: 'A critical error has occurred.'
    },
    valid: {
      alphabet: 'Only english alphabet',
      alphanumeric: 'Only alphanumeric',
      kana: 'Only japanese double-byte katakana',
      mail: '{0} must be valid',
      number: 'Only numbers',
      numberHyphen: 'Only numbers or hyphen',
      password: '8 or more alphanumeric symbols',
      required: '{0} is required',
      requiredBool: '{0} is required',
      url: '{0} must be valid'
    }
  },
  ja: {
    error: {
      SYSERR: 'システムエラーが発生しました。'
    },
    valid: {
      alphabet: '半角英字のみで入力してください',
      alphanumeric: '半角英数字のみで入力してください',
      kana: '全角カタカナで入力してください',
      mail: '{0} が正しくありません',
      number: '半角の数値のみで入力してください',
      numberHyphen: '半角の数値とハイフンのみで入力してください',
      password: '半角英数字を組み合わせた8桁以上で入力してください',
      required: '{0} は必須です',
      requiredBool: '{0} は必須です',
      url: '{0} が正しくありません'
    }
  }
}
